import { contents } from ".."
import SkillItem from "../../components/SkillItem"

const XeTraSua = () => {
    const project = contents.find((item) => item.slug === 'xe-tra-sua')!

    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32 rounded-md">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{project.title}</h2>
                            <div className="my-4">
                                {project.techStack.map((item, index: number) => (
                                    <SkillItem key={`xe-tra-sua-${index}-${item}`} label={item} />
                                ))}
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                Xe Trà Sữa is a browser game in Vietnamese where you run a milk tea shop. You buy ingredients, make drinks, serve customers, and learn new recipes.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                                This is a vibe coding project. I used AI tools to help write the code and create the game art and sounds. I built it with ChatGPT Work and the Game Studio plugin for ChatGPT.
                            </p>
                            <div className="mt-6">
                                <a
                                    className="inline-block rounded-md bg-indigo-600 px-4 py-2 font-semibold text-white hover:bg-indigo-500"
                                    href="https://xe-tra-sua.web.app/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Play Xe Trà Sữa
                                </a>
                            </div>
                            <h3 className="mt-8 text-xl font-bold text-gray-900">How I made it</h3>
                            <dl className="mt-4 space-y-4 text-lg leading-8 text-gray-600">
                                <div>
                                    <dt className="font-semibold text-gray-900">Code</dt>
                                    <dd>I used ChatGPT Work to help write the game code.</dd>
                                </div>
                                <div>
                                    <dt className="font-semibold text-gray-900">Skills and plugin</dt>
                                    <dd>I used the skills and tools in Game Studio, a ChatGPT plugin, to help build the game.</dd>
                                </div>
                                <div>
                                    <dt className="font-semibold text-gray-900">Sprites</dt>
                                    <dd>I used Imagegen, ChatGPT Work, and Game Studio to create the game sprites.</dd>
                                </div>
                                <div>
                                    <dt className="font-semibold text-gray-900">Background music</dt>
                                    <dd>I used Google Flow music for the background sound.</dd>
                                </div>
                                <div>
                                    <dt className="font-semibold text-gray-900">Sound effects</dt>
                                    <dd>I used ElevenLabs Sound Effects to turn text prompts into MP3 sound files for the game.</dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                    <div className="space-y-8 lg:pt-4">
                        <figure>
                            <img
                                src={require('../../assets/projects/xe-tra-sua/painted-tray-holder-counter.jpg')}
                                alt="Customers waiting for drinks at the milk tea counter"
                                className="h-auto w-full rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                width={1280}
                                height={720}
                            />
                            <figcaption className="mt-2 text-center text-gray-600">Make drinks to match each customer&apos;s order.</figcaption>
                        </figure>
                        <figure>
                            <img
                                src={require('../../assets/projects/xe-tra-sua/preparation-group-tabs.jpg')}
                                alt="Ingredient list and stock amounts before opening the milk tea shop"
                                className="h-auto w-full rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                width={845}
                                height={912}
                                loading="lazy"
                            />
                            <figcaption className="mt-2 text-center text-gray-600">Buy ingredients and get the shop ready before opening.</figcaption>
                        </figure>
                        <figure>
                            <img
                                src={require('../../assets/projects/xe-tra-sua/counter-overflow-fixed.jpg')}
                                alt="Milk tea counter with cups, drinks, toppings, and a cup sealing machine"
                                className="h-auto w-full rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                width={1280}
                                height={720}
                                loading="lazy"
                            />
                            <figcaption className="mt-2 text-center text-gray-600">Choose a cup, pour the drink, add toppings, and serve it.</figcaption>
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default XeTraSua
